<template>
<div id="app">
    <a-locale-provider :locale="locale">
        <a-spin :spinning="pageLoading" tip="数据加载中..." class="loading" size="large" >
            <a-spin :spinning="queryLoading" class="loading query_loading" size="large" >
                <div slot="indicator" style="width: 300px;margin: 20px 0 0 -150px;">
                    <span class="ant-spin-dot ant-spin-dot-spin"><i></i><i></i><i></i><i></i></span>
                    <div v-html="queryLoadingContent" class="ant-spin-text" style="font-size:14px; margin-top:20px;"></div>
                    <div class="ant-spin-cancel"><a @click="cancelQuery">取消查询</a></div>
                </div>
            <a-layout class="layout" :class="{'onepage': (!user.auth || user.auth=='normal') && $route.meta.index}">
                <a-layout-header class="header">
                    <div class="container">
                        <a class="logo" href="index.html"/>
                        <GameSwitch :type="$route.meta.index?'index':'game'"/>
                        <HeaderLink />
                    </div>
                </a-layout-header>
                <a-layout-content>
                    <router-view></router-view>
                </a-layout-content>
                <a-layout-footer>
                    <span>© 雷火UX用户体验中心 Copyright Leihuo. All Rights Reserved. 网易公司 版权所有</span>
                </a-layout-footer>
            </a-layout>
        </a-spin>
        </a-spin>
    </a-locale-provider>
</div>
</template>  

<script>
import zhCN from 'ant-design-vue/lib/locale-provider/zh_CN';
import enUS from 'ant-design-vue/lib/locale-provider/en_US';
import GameSwitch from '@/components/common/game_switch.vue'
import HeaderLink from '@/components/common/header_link'
import {cancelQuery} from '@/utils/axios'

export default {
    components: {
        GameSwitch,
        HeaderLink,
    },
    mounted() {
        this.getProjects()
        this.getUser()
    },
    methods: {
        getUser() {
            this.$store.dispatch("get_user")
        },
        getProjects() {
            this.$store.dispatch("get_projects", this.$route.meta.index || location.href.indexOf('game.html')<0?true:false).then(()=>{
                this.loading = false
            })
        },
        cancelQuery() {
            cancelQuery()
        }
    },
    watch: {
        loading(newV) {
            this.$store.commit('set_loading', newV)
        },
        query(newV) {
            this.queryFlag+=1
            if(newV === 0) {
                this.queryLoading = false
            }
            else if(newV === 1) {
                this.queryLoading= true
                this.queryLoadingContent = '数据计算中...'
            }
            else {
                this.queryLoading= true
                this.queryLoadingContent = '3'
                let flag = this.queryFlag
                setTimeout(()=>{
                    if(this.queryLoading=== true && flag == this.queryFlag) {
                        this.queryLoadingContent = '2'; 
                        setTimeout(()=>{
                            if(this.queryLoading=== true && flag == this.queryFlag) {
                                this.queryLoadingContent = '1';
                                setTimeout(()=>{
                                    if(this.queryLoading=== true && flag == this.queryFlag) {
                                        this.queryLoadingContent = `${this.$service.PROJ_CODE == 'l28' ? 'UX' : '数源'}管理的数据集群<br />正在计算中`;
                                    }
                                }, 1000)
                            }
                        }, 1000)
                    }
                }, 1000)
            }
        }
    },
    computed: {
        user() {
            return this.$store.state.user
        },
        pageLoading() {
            return this.$store.state.config.loading
        },
        query() {
            return this.$store.state.config.query
        },
        locale() {
            return this.$i18n.locale === 'en_US' ? enUS : zhCN;
        }
    },
    data() {
        return {
            loading: true,
            admin: false,
            queryLoading: false,
            queryLoadingContent: '3',
            queryFlag:1,
        }
    },
}
</script>

<style lang="less" scoped>
.pageloading {
    position:fixed;
    width:100%;
    height: 100%;
    z-index: 10000;
}
.spinning_modal {
    position:fixed;
    width:100%;
    height: 100%;
    z-index: 10000;
}

.ant-spin-cancel {
    position: absolute;
    top: 50%;
    left: 0;
    width: 100%;
    font-size: 14px;
    margin: 90px 0 0 0;
    a {
        background: #1890ff;
        border-radius: 5px;
        padding: 5px 20px;
        color: #fff;
        &:hover {
            background: #40a9ff;

        }
    }
}
</style>
<style lang="less">
.query_loading {
    &.ant-spin-nested-loading > div > .ant-spin .ant-spin-dot {
        position: fixed;
    }
    > .ant-spin-blur {
        overflow: unset;
    }
}
</style>